let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3U2Yj")).then(() => parcelRequire('6mZms'));